import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-fluid gx-lg-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "Receiver Event Archives", -1)
const _hoisted_3 = {
  class: "btn-toolbar",
  role: "toolbar",
  "aria-label": "Event Actions"
}
const _hoisted_4 = {
  class: "btn-group me-2",
  role: "group",
  "aria-label": "Event actions"
}
const _hoisted_5 = { class: "panel" }
const _hoisted_6 = { "aria-label": "Page navigation" }
const _hoisted_7 = { class: "row justify-content-center" }
const _hoisted_8 = { class: "col-sm-2" }
const _hoisted_9 = { class: "col-sm-4" }
const _hoisted_10 = {
  key: 0,
  class: "pagination justify-content-center"
}
const _hoisted_11 = {
  key: 1,
  class: "page-link"
}
const _hoisted_12 = { class: "col-sm-2" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "table-responsive" }
const _hoisted_15 = { class: "table table-striped" }
const _hoisted_16 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Type"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Date"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Actions")
  ])
], -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getList())),
          class: "btn btn-outline-primary"
        }, "Refresh")
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("nav", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _withDirectives(_createVNode("select", {
              class: "form-select",
              "aria-label": "Results per page",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.requestPaging.Limit = $event)),
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getList()))
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.requestPaging.Options, (item) => {
                return (_openBlock(), _createBlock("option", {
                  key: item,
                  value: item
                }, _toDisplayString(item), 9, ["value"]))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.requestPaging.Limit]
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            (_ctx.pageBounds)
              ? (_openBlock(), _createBlock("ul", _hoisted_10, [
                  _createVNode("li", {
                    class: ["page-item", _ctx.backendResponse.count > _ctx.requestPaging.Limit && _ctx.requestPaging.Skip > 0 ? '' : 'disabled']
                  }, [
                    _createVNode("a", {
                      class: "page-link",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setPage('-1'))),
                      href: "#",
                      tabindex: "-1",
                      "aria-disabled": "true"
                    }, "Previous")
                  ], 2),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pageBounds, (page) => {
                    return (_openBlock(), _createBlock("li", {
                      key: page.number,
                      class: ['page-item', page.current == true ? 'active' : '', page.number == 0 ? 'disabled' : '']
                    }, [
                      (page.number > 0)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            class: "page-link",
                            href: "#",
                            onClick: ($event: any) => (_ctx.setPage(page.number))
                          }, _toDisplayString(page.number), 9, ["onClick"]))
                        : (_openBlock(), _createBlock("a", _hoisted_11, "…"))
                    ], 2))
                  }), 128)),
                  _createVNode("li", {
                    class: ["page-item", _ctx.backendResponse.count > (_ctx.requestPaging.Limit + _ctx.requestPaging.Skip) ? '' : 'disabled']
                  }, [
                    _createVNode("a", {
                      class: "page-link",
                      href: "#",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setPage('+1')))
                    }, "Next")
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_12, [
            (_ctx.backendResponse.count > 0)
              ? (_openBlock(), _createBlock("p", _hoisted_13, _toDisplayString(_ctx.requestPaging.Skip > 0 ? _ctx.requestPaging.Skip : 1) + " to " + _toDisplayString(Math.min(_ctx.requestPaging.Skip + _ctx.requestPaging.Limit, _ctx.backendResponse.count)) + " of " + _toDisplayString(_ctx.backendResponse.count), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("table", _hoisted_15, [
        _hoisted_16,
        _createVNode("tbody", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.backendResponse.items, (event) => {
            return (_openBlock(), _createBlock("tr", {
              key: event.id
            }, [
              _createVNode("td", null, _toDisplayString(event.EventType), 1),
              _createVNode("td", null, _toDisplayString(_ctx.getHumanDate(event.EventDate)), 1),
              _createVNode("td", null, [
                _createVNode("button", {
                  onClick: ($event: any) => (_ctx.getDownload(event.id)),
                  class: "btn btn-outline-primary"
                }, "Download", 8, ["onClick"]),
                _hoisted_17,
                _createVNode("button", {
                  onClick: ($event: any) => (_ctx.deleteArchive(event.id)),
                  class: "btn btn-outline-danger"
                }, "Purge", 8, ["onClick"])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}